import * as React from 'react'

import { observer } from 'mobx-react'

import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import Delivery from '~/client/src/shared/models/Delivery'

import DeliveryWorkflowCard from '../../ExpandableWorkflowCard/components/DeliveryWorkflowCard'
import SitemapDraggableModalWrapper from '../SitemapDraggableModalWrapper'

interface IProps {
  item: MapViewItemBase
  onClose: () => void
  activeDeliveryId: string
  containerRef: HTMLElement
  relatedDeliveries: Delivery[]
  onFilterResetClick: () => void
  onDeliveryClick: (deliveryId: string) => void
  topOffset: number
  leftOffset: number
}

const noActiveDeliveries = 'No active deliveries'
@observer
export default class SitemapDeliveriesDraggableModal extends React.Component<IProps> {
  public static defaultProps = {
    relatedDeliveries: [],
  }

  public render() {
    const {
      item,
      containerRef,
      onClose,
      relatedDeliveries,
      topOffset,
      leftOffset,
    } = this.props

    return (
      <SitemapDraggableModalWrapper
        className="overflow-auto"
        item={item}
        containerRef={containerRef}
        onClose={onClose}
        topOffset={topOffset}
        leftOffset={leftOffset}
      >
        <div className="relative overflow-auto draggable-elements-list">
          {relatedDeliveries?.length ? (
            relatedDeliveries.map(delivery => {
              return (
                <DeliveryWorkflowCard
                  key={delivery.id}
                  className="full-height"
                  delivery={delivery}
                  onClick={this.onDeliveryClick}
                />
              )
            })
          ) : (
            <div className="text grey pa10">{noActiveDeliveries}</div>
          )}
        </div>
      </SitemapDraggableModalWrapper>
    )
  }

  private onDeliveryClick = (delivery: Delivery): void => {
    this.props.onDeliveryClick(delivery.id)
  }
}
